import { useEffect } from "react";

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

export const useMeta = ({ title, description, image, type = "website" }) => {
  useEffect(() => {
    if (!title) return;
    const prevTitle = document.title;
    const url = window.location.href;
    const ogImage = image || `${window.location.origin}/og-cover.png`;
    document.title = `${title} — YLBH Sumatera Timur`;
    setMeta("property", "og:site_name", "YLBH Sumatera Timur");
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description || "");
    setMeta("property", "og:type", type);
    setMeta("property", "og:url", url);
    if (ogImage) setMeta("property", "og:image", ogImage);
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description || "");
    setMeta("name", "twitter:image", ogImage);
    return () => {
      document.title = prevTitle;
    };
  }, [title, description, image, type]);
};
